/* eslint-disable react/no-danger */
/**
 *
 * FilledToggleButton
 *
 */

import {useCallback, useEffect, useRef, useState} from "react";
import {Button, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import * as PropTypes from "prop-types";
import clsx from "clsx";
import oring from "../../images/oring.png"
import hoefijzer from "../../images/hoefijzer.png"
import palatalstrap from "../../images/palatalstrap.png"
import lingualplate from "../../images/lingualplate.png"
import lingualbar from "../../images/lingualbar.png"
import kennedybar from "../../images/kennedybar.png"

const useStyles = makeStyles(theme => ({
  wrapper: {
    position: "relative",
  },
  container: {
    minWidth: ({ length }) => `${length * 50}px`,
    borderRadius: "25px",
    display: "flex",
    flexDirection: "row",
    border: ({ borderColor, hasError }) => {
      return `1px solid ${hasError ? '#e68058' : borderColor}`
    },
    overflow: "hidden",
    position: "relative",
    width: "100%",
  },
  button: {
    flex: 1,
    borderRadius: "25px",
    minHeight: "30px",
    maxHeight: "36px",

    "& > span": {
      width: "100%",
      height: "100%",
    },

    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  overlayWrapper: {
    position: "absolute",
    left: "-1px",
    top: "-1px",
    width: "100%",
    height: "calc(100% + 2px)",
    display: "flex",
  },
  label: {
    position: "absolute",
    left: 20,
    backgroundColor: "white",
    display: "block",
    zIndex: 1,
    color: "rgba(0,0,0,0.56)",
    fontSize: "14px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "no-wrap",
    padding: "0 10px",
    marginTop:"2px",
    maxWidth: "100%",
    top: ({ label }) => -label / 2 || 0,
  },
  overlay: {
    backgroundClip: "padding-box",
    transition: "transform 300ms",
    flexBasis: props => `calc((100% + 2px) / ${props.length})`,
    transform: props => `translateX(${props.index * 100}%)`,
    border: ({ activeBorderColor, activeBackgroundColor }) =>
      activeBackgroundColor === activeBorderColor
        ? "none"
        : `1px solid ${activeBorderColor}`,
    borderRadius: "25px",
    height: "100%",
    backgroundColor: ({ activeBackgroundColor }) => activeBackgroundColor,
  },
}));

function ToggleButton({
  options,
  onChange,
  value,
  textColor = "#b4b4b4",
  activeTextColor = "#000",
  activeBackgroundColor = "transparent",
  borderColor = "#000",
  activeBorderColor = "#000",
  label,
  className,
  hasError = false,
  disabled = false,
  dataCy,
}) {
  const labelRef = useRef(null);
  const [labelHeight, setLabelHeight] = useState(0);

  useEffect(() => {
    if (labelRef && labelRef.current) {
      setLabelHeight(labelRef.current.offsetHeight);
    }
  }, []);

  const getIndex = useCallback(
    () => options.findIndex(option => option.value === value),
    [options, value],
  );

  const classes = useStyles({
    index: getIndex(),
    length: options.length,
    activeBackgroundColor,
    borderColor,
    activeBorderColor,
    label: labelHeight,
    hasError,
  });
  var isupperframequestion = false;
  var islowerframequestion = false;
  //here
  if(options){
    if(options.find(o => o.label == "O-ring")){
      isupperframequestion = true
    }
    if(options.find(o => o.label == "Lingual plate")){
      islowerframequestion = true
    }
  }
  return (
    <>
      {(() => {
        if(isupperframequestion){
          return <div style={{display:"flex",justifyContent:"center"}}>
            <img style={{cursor:"pointer",opacity:value == 1 ? 1 : 0.5}} onClick={() => {
              if(disabled){
                return
              }
              onChange(options[0])
            }} src={oring}></img>
            <img style={{cursor:"pointer",opacity:value == 2 ? 1 : 0.5}} onClick={() => {
              if(disabled){
                return
              }
              onChange(options[1])
            }}src={hoefijzer}></img>
            <img style={{cursor:"pointer",opacity:value == 3 ? 1 : 0.5}} onClick={() => {
              if(disabled){
                return
              }
              onChange(options[2])
            }}src={palatalstrap}></img>
          </div>
        }
        if(islowerframequestion){
          return <div style={{display:"flex",justifyContent:"center"}}>
            <img style={{cursor:"pointer",opacity:value == 1 ? 1 : 0.5}} onClick={() => {
              if(disabled){
                return
              }
              onChange(options[0])
            }}src={lingualplate}></img>
            <img style={{cursor:"pointer",opacity:value == 2 ? 1 : 0.5}} onClick={() => {
              if(disabled){
                return
              }
              onChange(options[1])
            }}src={lingualbar}></img>
            <img style={{cursor:"pointer",opacity:value == 3 ? 1 : 0.5}} onClick={() => {
              if(disabled){
                return
              }
              onChange(options[2])
            }}src={kennedybar}></img>
          </div>
        }
      })()}
      <div className={clsx(classes.wrapper, className)} data-cy={dataCy}>
        
        {label && (
          <Typography noWrap className={classes.label} ref={labelRef}>
            {label}
          </Typography>
        )}
        <div className={classes.container}>
          {/* <div className={classes.overlayWrapper}>
            <div className={classes.overlay} />
          </div> */}
          {options.map(option => (
            <Button
              data-cy={option.id}
              disabled={disabled}
              key={option.value}
              disableRipple
              style={{
                color: disabled
                  ? textColor
                  : value === option.value
                    ? activeTextColor
                    : textColor,
                stroke: disabled
                  ? textColor
                  : value === option.value
                    ? activeTextColor
                    : textColor,
                border:value === option.value ? "3px solid black" : "0px solid black",
                minHeight: "30px",
                maxHeight: "36px",
              }}
              onClick={() => onChange(option)}
              className={classes.button}
            >
              {option.svgPath ? (
                <div
                  style={{
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    height: "100%",
                    width: "100%",
                    maxWidth: "120px",
                  }}
                  dangerouslySetInnerHTML={{ __html: option.svgPath }}
                />
              ) : (
                <div
                  style={{
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {option.label}
                </div>
              )}
            </Button>
          ))}
        </div>
      </div>
    </>
  );
}

ToggleButton.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.any,
      id: PropTypes.any,
      value: PropTypes.any,
      svgPath: PropTypes.any,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any.isRequired,
  textColor: PropTypes.string,
  label: PropTypes.any,
  activeTextColor: PropTypes.string,
  activeBackgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  activeBorderColor: PropTypes.string,
};

export default ToggleButton;
